module.exports = __webpack_public_path__ + "img/logo.ab419a28.jpg";